import React, { Component } from "react";
import {
    MDBInput, MDBBadge, MDBBtn, MDBContainer, MDBNavbar, MDBNavbarNav, MDBNavItem,
    MDBNavLink, MDBIcon, MDBSideNavItem, MDBSideNavNav, MDBSideNav, MDBSideNavLink, MDBSideNavCat,
    MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter
} from "mdbreact";
import AccessManager from '../../Utilities/AccessManager';
import DataLayer from '../../Utilities/DataLayer';

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.state = {
            toggleStateA: false,
            breakWidth: 1400,
            windowWidth: 0,
            ID: "",
            URL: "",
            FirstName: "",
            LastName: "",
            Email: "",
            Lang: "",
            Country: "",
            Hash: "",
            Timestamp: "",
            modalOpen: false,
            isTuppsocial: false,
            dealerId: "",
            connectUrl: "",
            Target: "",
            Signature: ""
        }

        this.accessManager = new AccessManager();
        this.submitSocial = this.submitSocial.bind(this);
        this.submitConnect = this.submitConnect.bind(this);
    }

    toggleTuppSocialModal = (proceed, isTuppSocial) => {
        this.setState({
            modalOpen: !this.state.modalOpen,
            isTuppsocial: isTuppSocial
        })
        if (proceed) {
            if (isTuppSocial) {
                this.submitSocial();
            } else {
                this.submitConnect();
            }
        }
    }

    sidenavToggle = sidenavId => () => {
        this.props.setNavParam(sidenavId);
    };

    async submitConnect() {
        var dl = new DataLayer();
        let myTesterDDDJDJ = "";
        let response = await dl.Get('/demonstrator/GetConnectParams/');
        let mytester = "";
        this.setState({
            dealerId: response.data.dealerId,
            Target: response.data.target,
            connectURL: response.data.url,
            Signature: response.data.signature,
            Lang: response.data.language,
            Country: response.data.country,
            Timestamp: response.data.timestamp
        });
        console.log(this.props.connectUrl + "?DealerUID=" + this.state.dealerId +"&TimeStamp=" + this.state.Timestamp + "&Target=" + this.state.Target + "&Signature=" + this.state.Signature)
        document.getElementById("connectForm").action = this.props.connectUrl + "?DealerUID=" + this.state.dealerId + "&TimeStamp=" + this.state.Timestamp + "&Target=" + this.state.Target + "&Signature=" + this.state.Signature;
        document.getElementById("connectForm").submit();
    }

    async submitSocial() {
        var dl = new DataLayer();
        let response = await dl.Get('/demonstrator/GetTuppSocialParams/');


        this.setState({
            ID: response.data.id,
            LastName: response.data.lastName,
            URL: response.data.url,
            FirstName: response.data.firstName,
            Email: response.data.email,
            Lang: response.data.lang,
            Country: response.data.country,
            Hash: response.data.hash,
            Timestamp: response.data.timestamp
        });
        //alert('timeStamp: ' + ts);
        
        document.getElementById("socialForm").submit();
        //console.log(document.getElementById("socialForm"))
    }

    componentDidMount = () => {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () =>
        this.setState({
            windowWidth: window.innerWidth
        });

    handleToggleClickA = () => {
        this.setState({
            toggleStateA: !this.state.toggleStateA
        });
    };

    render() {
        const navStyle = {
            paddingLeft:
                this.state.windowWidth > this.state.breakWidth ? "210px" : "16px"


        };
        const mainStyle = {
            margin: "0 6%",
            paddingTop: "5.5rem",
            paddingLeft:
                this.state.windowWidth > this.state.breakWidth ? "240px" : "0"
        };
        const specialCaseNavbarStyles = {
            WebkitBoxOrient: "horizontal",
            flexDirection: "row"
        };
        let userType = this.TMAUser.data.loginType
        return (

            <div>

                <MDBSideNav
                    logo="https://tupp.tuppafrica.co.za/imgs/TWlogo2024.png"
                    triggerOpening={this.state.toggleStateA}
                    breakWidth={this.state.breakWidth}
                    fixed
                    className="navBackround pt-2"
                >
                    
                        <ul className="social">
                            <li>
                                {JSON.parse(localStorage.getItem("TMAUser")).data.demonstratorName} <br />
                                    {JSON.parse(localStorage.getItem("TMAUser")).data.sfCurrentCode}<br />
                                    Current Week: {JSON.parse(localStorage.getItem("TMAUser")).data.weekId}<br />
                                    Balance: {this.props.currentBalance < 0 ? <span style={{ color: "red", fontWeight: "bold" }}>{(this.props.currentBalance) * -1}</span> : <span>{this.props.currentBalance}</span>}

                        </li>
                        </ul>
                    <ul className="social">
                            <li>
                                Level: {this.props.levelName}
                                    {/*Discount %: { this.props.levelPercentage}*/}
                                

                            </li>
                            
                                    {this.TMAUser.data.statusCode1 == 'D' ? (
                                        <div>
                                    <li>Manager: {this.props.managerName}<br />
                                            Unit: {this.props.unitName}<br />
                                            Cell: {this.props.managerCell}</li> 
                                       </div> ) : (<div></div>)}
                                

                        </ul>
                    
                    <MDBSideNavNav>
                        {
                            this.props.navItems.map(item => {
                                if (item.children === undefined || item.children === null) {
                                    return (
                                        <div hidden={item.nodeHidden === undefined || item.nodeHidden === null ? false : item.nodeHidden}>
                                        <MDBSideNavLink to={item.route}>
                                            <MDBIcon className="mr-2" icon={item.iconName} />{item.text}
                                            </MDBSideNavLink>
                                            </div>
                                    )
                                } else {
                                    return (
                                        <MDBSideNavCat name={item.text} id={item.id} icon={item.iconName}>
                                            {item.children.map(subItem => {
                                                return (
                                                    <MDBSideNavLink to={subItem.route} onClick={this.sidenavToggle(subItem.text)}>
                                                        <MDBIcon className="mr-2" icon={subItem.iconName} />{subItem.text}
                                                    </MDBSideNavLink>
                                                )
                                            })}

                                        </MDBSideNavCat>
                                    )
                                }

                            })
                        }


                    </MDBSideNavNav>

                </MDBSideNav>

                <MDBNavbar className="myNavBar" style={navStyle} double expand="md" fixed="top" scrolling>
                    <MDBNavbarNav left>
                        <MDBNavItem>
                            <div
                                onClick={this.handleToggleClickA}
                                key="sideNavToggleA"
                                style={{
                                    lineHeight: "32px",
                                    marginRight: "1em",
                                    verticalAlign: "middle"
                                }}
                            >
                                <MDBIcon icon="bars" color="white" size="2x" />
                            </div>
                        </MDBNavItem>

                    </MDBNavbarNav>
                    <MDBNavbarNav right style={specialCaseNavbarStyles}>
                        {this.props.cartHidden ? (<div></div>) : (
                            <MDBNavItem active>
                                <MDBNavLink to={userType == 'SF' ? "/salesforce/cart" : "/salesforce/vscart"} style={{ marginRight: "1rem" }}>
                                    <div>
                                        <span>
                                            <MDBIcon icon="shopping-cart" />
                                        </span>
                                        <span className="cartBadge">
                                            <MDBBadge color="danger">{this.props.cartItemCount}</MDBBadge>
                                        </span>

                                    </div>

                                </MDBNavLink>
                            </MDBNavItem>)}
                        {/*{this.props.allowTuppSocial ? (*/}
                        {/*    <form*/}
                        {/*        className="needs-validation"*/}
                        {/*        name="socialFrom"*/}
                        {/*        id="socialForm"*/}
                        {/*        action={this.props.tuppSocialUrl}*/}
                        {/*        method="post"*/}
                        {/*    >*/}
                        {/*        <input type="hidden" id="id" name="id" value={this.state.ID} />*/}
                        {/*        <input type="hidden" id="url" name="url" value={this.state.URL} />*/}
                        {/*        <input type="hidden" id="first_name" name="first_name" value={this.state.FirstName} />*/}
                        {/*        <input type="hidden" id="last_name" name="last_name" value={this.state.LastName} />*/}
                        {/*        <input type="hidden" id="email" name="email" value={this.state.Email} />*/}
                        {/*        <input type="hidden" id="lang" name="lang" value={this.state.Lang} />*/}
                        {/*        <input type="hidden" id="country" name="country" value={this.state.Country} />*/}
                        {/*        <input type="hidden" id="t" name="t" value={this.state.Timestamp} />*/}
                        {/*        <input type="hidden" id="h" name="h" value={this.state.Hash} />*/}
                        {/*        <MDBNavItem active>*/}
                        {/*            <MDBNavLink onClick={() => this.toggleTuppSocialModal(false, true)}>*/}
                        {/*                <MDBIcon icon="users" className="d-inline-inline" />&nbsp;*/}
                        {/*            <div className="d-none d-md-inline">Tupp Social</div>*/}

                        {/*            </MDBNavLink>*/}
                        {/*        </MDBNavItem>*/}
                        {/*    </form>*/}
                        {/*) : (<div></div>)}*/}
                        {/*{this.props.share ? (*/}
                        {/*    <form*/}
                        {/*        className="needs-validation"*/}
                        {/*        name="connectForm"*/}
                        {/*        id="connectForm"*/}
                        {/*        action={this.props.connectUrl}*/}
                        {/*        method="post"*/}
                        {/*    >*/}
                        {/*        */}{/* <input type="hidden" id="dealerId" name="dealerId" value={this.state.dealerId} />*/}{/*
                        */}{/*        <input type="hidden" id="connectUrl" name="connectUrl" value={this.state.ConnectURL} />*/}{/*
                        */}{/*        <input type="hidden" id="target" name="target" value={this.state.Target} />*/}{/*
                        */}{/*        <input type="hidden" id="signature" name="signature" value={this.state.Signature} />*/}{/*
                        */}{/*        <input type="hidden" id="language " name="language" value={this.state.Lang} />*/}{/*
                        */}{/*        <input type="hidden" id="country" name="country" value={this.state.Country} />*/}{/*
                        */}{/*        <input type="hidden" id="timeStamp" name="timeStamp" value={this.state.Timestamp} /> */}
                                
                        {/*    <MDBNavItem active>*/}
                        {/*    <MDBNavLink to="" onClick={() => this.toggleTuppSocialModal(false, false)}>*/}
                        {/*        <MDBIcon icon="link" className="d-inline-inline" />&nbsp;*/}
                        {/*            <div className="d-none d-md-inline">Connect</div>*/}

                        {/*    </MDBNavLink>*/}
                        {/*        </MDBNavItem>*/}
                        {/*    </form>) : (<div></div>)}*/}
                        <MDBNavItem active>
                            <MDBNavLink to="" onClick={this.accessManager.logout}>
                                <MDBIcon icon="sign-out-alt" className="d-inline-inline" />&nbsp;
                                    <div className="d-none d-md-inline">Logout</div>

                            </MDBNavLink>
                        </MDBNavItem>


                    </MDBNavbarNav>
                </MDBNavbar>

                <MDBModal isOpen={this.state.modalOpen} toggle={this.state.modalOpen} centered>
                    <MDBModalHeader>Warning</MDBModalHeader>
                    <MDBModalBody>
                        You are about to navigate away from Mobi. If you choose proceed standard data rates/charges will apply.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.toggleTuppSocialModal(false, this.state.isTuppsocial)}>Cancel</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.toggleTuppSocialModal(true, this.state.isTuppsocial)}>Proceed</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>

        );
    }
}

export default Navigation;
